import request from "../http/index";

/**
 *
 * @param {*} data
 * @returns 授权关系列表
 */

//获取列表
export async function CusRelationAuthorityList(data = {}) {
	const res = await request.post("/api/ba/CusRelationAuthority/List", data);
	return res.data;
}

//下载模板
export async function TempletCusRelationAuthority(data = {}) {
	const res = await request.post(
		"/api/ba/CusRelationAuthority/DownloadTemplet",
		data
	);
	return res.data;
}

//导入
export async function ImportCusRelationAuthority(data = {}) {
	const res = await request.post("/api/ba/CusRelationAuthority/Import", data);
	return res.data;
}

//导出
export async function ExportCusRelationAuthority(data = {}) {
	const res = await request.post("/api/ba/CusRelationAuthority/Export", data, {
		responseType: "blob",
	});
	return res.data;
}

//删除
export async function DeleteCusRelationAuthority(data = {}) {
	const res = await request.post("/api/ba/CusRelationAuthority/Delete", data);
	return res.data;
}

//新增
export async function AddCusRelationAuthority(data = {}) {
	const res = await request.post("/api/ba/CusRelationAuthority/Add", data);
	return res.data;
}

//编辑
export async function EditCusRelationAuthority(data = {}) {
	const res = await request.post("/api/ba/CusRelationAuthority/Edit", data);
	return res.data;
}

//详情
export async function InfoCusRelationAuthority(data = {}) {
	const res = await request.post("/api/ba/CusRelationAuthority/Info", data);
	return res.data;
}

//QuotaCustomerRatio

//列表
export async function GetQuotaCustomerRatioList(data = {}) {
	const res = await request.post("/api/ba/QuotaCustomerRatio/List", data);
	return res.data;
}

//详情
export async function GetQuotaCustomerRatioInfo(data = {}) {
	const res = await request.post("/api/ba/QuotaCustomerRatio/Info", data);
	return res.data;
}

//添加
export async function AddQuotaCustomerRatio(data = {}) {
	const res = await request.post("/api/ba/QuotaCustomerRatio/Add", data);
	return res.data;
}

//编辑
export async function EditQuotaCustomerRatio(data = {}) {
	const res = await request.post("/api/ba/QuotaCustomerRatio/Edit", data);
	return res.data;
}

//内部指标-月度比例 QuotaInnerRatio
//列表
export async function GetQuotaInnerRatioList(data = {}) {
	const res = await request.post("/api/ba/QuotaInnerRatio/List", data);
	return res.data;
}

//详情
export async function GetQuotaInnerRatioInfo(data = {}) {
	const res = await request.post("/api/ba/QuotaInnerRatio/Info", data);
	return res.data;
}

//添加
export async function AddQuotaInnerRatio(data = {}) {
	const res = await request.post("/api/ba/QuotaInnerRatio/Add", data);
	return res.data;
}

//编辑
export async function EditQuotaInnerRatio(data = {}) {
	const res = await request.post("/api/ba/QuotaInnerRatio/Edit", data);
	return res.data;
}

///QuotaIMSYear
//列表
export async function GetQuotaIMSYearList(data = {}) {
	const res = await request.post("/api/ba/QuotaIMSYear/List", data);
	return res.data;
}

//详情
export async function GetQuotaIMSYearInfo(data = {}) {
	const res = await request.post("/api/ba/QuotaIMSYear/Info", data);
	return res.data;
}

//模板
export async function DownloadQuotaIMSYear(data = {}) {
	const res = await request.post("/api/ba/QuotaIMSYear/DownloadTemplet", data);
	return res.data;
}

//导入
export async function ImportQuotaIMSYearInfo(data = {}) {
	const res = await request.post("/api/ba/QuotaIMSYear/Import", data, {
		headers: {
			"Content-Type": "multipart/form-data;",
		},
	});
	return res.data;
}

//添加
export async function AddQuotaIMSYear(data = {}) {
	const res = await request.post("/api/ba/QuotaIMSYear/Add", data);
	return res.data;
}

//编辑
export async function EditQuotaIMSYear(data = {}) {
	const res = await request.post("/api/ba/QuotaIMSYear/Edit", data);
	return res.data;
}

//删除
export async function DeleteQuotaIMSYear(data = {}) {
	const res = await request.post("/api/ba/QuotaIMSYear/Delete", data);
	return res.data;
}

///QuotaInnerYear
//列表
export async function GetQuotaInnerYearList(data = {}) {
	const res = await request.post("/api/ba/QuotaInnerYear/List", data);
	return res.data;
}

//详情
export async function GetQuotaInnerYearInfo(data = {}) {
	const res = await request.post("/api/ba/QuotaInnerYear/Info", data);
	return res.data;
}

//模板
export async function DownloadQuotaInnerYear(data = {}) {
	const res = await request.post(
		"/api/ba/QuotaInnerYear/DownloadTemplet",
		data
	);
	return res.data;
}

//导入
export async function ImportQuotaInnerYearInfo(data = {}) {
	const res = await request.post("/api/ba/QuotaInnerYear/Import", data, {
		headers: {
			"Content-Type": "multipart/form-data;",
		},
	});
	return res.data;
}

//添加
export async function AddQuotaInnerYear(data = {}) {
	const res = await request.post("/api/ba/QuotaInnerYear/Add", data);
	return res.data;
}

//编辑
export async function EditQuotaInnerYear(data = {}) {
	const res = await request.post("/api/ba/QuotaInnerYear/Edit", data);
	return res.data;
}

//删除
export async function DeleteQuotaInnerYear(data = {}) {
	const res = await request.post("/api/ba/QuotaInnerYear/Delete", data);
	return res.data;
}

///QuotaCustomer
//列表
export async function GetQuotaCustomerList(data = {}) {
	const res = await request.post("/api/ba/QuotaCustomer/List", data);
	return res.data;
}

//详情
export async function GetQuotaCustomerInfo(data = {}) {
	const res = await request.post("/api/ba/QuotaCustomer/Info", data);
	return res.data;
}

//模板
export async function DownloadQuotaCustomer(data = {}) {
	const res = await request.post("/api/ba/QuotaCustomer/DownloadTemplet", data);
	return res.data;
}

//年度导入
export async function ImportQuotaCustomerYearInfo(data = {}) {
	const res = await request.post("/api/ba/QuotaCustomer/ImportYear", data, {
		headers: {
			"Content-Type": "multipart/form-data;",
		},
	});
	return res.data;
}

//月度导入
export async function ImportQuotaCustomerMonthInfo(data = {}) {
	const res = await request.post("/api/ba/QuotaCustomer/ImportMonth", data, {
		headers: {
			"Content-Type": "multipart/form-data;",
		},
	});
	return res.data;
}

//添加
export async function AddQuotaCustomer(data = {}) {
	const res = await request.post("/api/ba/QuotaCustomer/Add", data);
	return res.data;
}

//编辑
export async function EditQuotaCustomer(data = {}) {
	const res = await request.post("/api/ba/QuotaCustomer/Edit", data);
	return res.data;
}

//删除
export async function DeleteQuotaCustomer(data = {}) {
	const res = await request.post("/api/ba/QuotaCustomer/Delete", data);
	return res.data;
}

///QuotaCustomerVerify
//列表
export async function GetQuotaCustomerVerifyList(data = {}) {
	const res = await request.post("/api/ba/QuotaCustomerVerify/List", data);
	return res.data;
}

//详情
export async function GetQuotaCustomerVerifyInfo(data = {}) {
	const res = await request.post("/api/ba/QuotaCustomerVerify/Info", data);
	return res.data;
}

//编辑
export async function EditQuotaCustomerVerify(data = {}) {
	const res = await request.post("/api/ba/QuotaCustomerVerify/Edit", data);
	return res.data;
}

//审核
export async function VerifyQuotaCustomer(data = {}) {
	const res = await request.post("/api/ba/QuotaCustomerVerify/Verify", data);
	return res.data;
}

//弃审
export async function UnVerifyQuotaCustomer(data = {}) {
	const res = await request.post("/api/ba/QuotaCustomerVerify/UnVerify", data);
	return res.data;
}

//导出
export async function ExportQuotaCustomerVerify(data = {}) {
	const res = await request.post("/api/ba/QuotaCustomerVerify/Export", data, {
		responseType: "blob",
	});
	return res.data;
}

//医院ims-指标汇总

//医院IMS销售指标汇总表
export async function GetQuotaIMSSummary(data = {}) {
	const res = await request.post("/api/ba/QuotaIMS/Summary", data);
	return res.data;
}

//列表
export async function GetQuotaIMSList(data = {}) {
	const res = await request.post("/api/ba/QuotaIMS/List", data);
	return res.data;
}

//详情
export async function GetQuotaIMSInfo(data = {}) {
	const res = await request.post("/api/ba/QuotaIMS/Info", data);
	return res.data;
}

//导出
export async function ExportQuotaIMSInfo(data = {}) {
	const res = await request.post("/api/ba/QuotaIMS/Export", data, {
		responseType: "blob",
	});
	return res.data;
}

//编辑
export async function EditQuotaIMS(data = {}) {
	const res = await request.post("/api/ba/QuotaIMS/Edit", data);
	return res.data;
}

//内部指标-指标汇总

//医院IMS销售指标汇总表
export async function GetQuotaInnerSummary(data = {}) {
	const res = await request.post("/api/ba/QuotaInner/Summary", data);
	return res.data;
}

//列表
export async function GetQuotaInnerList(data = {}) {
	const res = await request.post("/api/ba/QuotaInner/List", data);
	return res.data;
}

//详情
export async function GetQuotaInnerInfo(data = {}) {
	const res = await request.post("/api/ba/QuotaInner/Info", data);
	return res.data;
}

//导出
export async function ExportQuotaInnerInfo(data = {}) {
	const res = await request.post("/api/ba/QuotaInner/Export", data, {
		responseType: "blob",
	});
	return res.data;
}

//编辑
export async function EditQuotaInner(data = {}) {
	const res = await request.post("/api/ba/QuotaInner/Edit", data);
	return res.data;
}

/**
 *
 * 业务透视相关接口
 *
 */

// l1 数据
export async function GetHelperLevel1(data = {}) {
	const res = await request.post("/api/helper/Helper/LEVEL1", data);
	return res.data;
}

// l2 条件数据
export async function GetHelperLevel2(data = {}) {
	const res = await request.post("/api/helper/Helper/LEVEL2", data);
	return res.data;
}

// l3 条件数据
export async function GetHelperLevel3(data = {}) {
	const res = await request.post("/api/helper/Helper/LEVEL3", data);
	return res.data;
}

// l4 条件数据
export async function GetHelperLevel4(data = {}) {
	const res = await request.post("/api/helper/Helper/LEVEL4", data);
	return res.data;
}

// 公司商业
export async function GetSMSReportZylox(data = {}) {
	const res = await request.post(
		"/api/report/SMSReport/ZyloxBusinessSummary",
		data
	);
	return res.data;
}

// 公司商业历年销售
export async function GetSMSReportZyloxBySales(data = {}) {
	const res = await request.post(
		"/api/report/SMSReport/ZyloxBusinessBySalesAmount",
		data
	);
	return res.data;
}

// L3商业销量趋势图
export async function GetSMSReportZyloxTendency(data = {}) {
	const res = await request.post(
		"/api/report/SMSReport/ZyloxBusinessTendency",
		data
	);
	return res.data;
}

// 首页热力图
export async function GetProvinceSalesAmount(data = {}) {
	const res = await request.post(
		"/api/report/QuotaReport/ProvinceSalesAmount",
		data
	);
	return res.data;
}

// 医院top 20
export async function GetHospitalSalesTOP(data = {}) {
	const res = await request.post(
		"/api/report/SMSReport/ZyloxHospitalSalesTOP",
		data
	);
	return res.data;
}

// IMS销售历史销量图
export async function SMSReportZyloxHospitalBySalesAmount(data = {}) {
	const res = await request.post(
		"/api/report/SMSReport/ZyloxHospitalBySalesAmount",
		data
	);
	return res.data;
}

// L3医院销量趋势图
export async function GetSMSReportZyloxHospitalTendency(data = {}) {
	const res = await request.post(
		"/api/report/SMSReport/ZyloxHospitalSalesByTendency",
		data
	);
	return res.data;
}

// 二级销售（大区）
export async function GetHelperAreaMan(data = {}) {
	const res = await request.post("/api/helper/Helper/AreaMan", data);
	return res.data;
}

// 三级销售（地区）
export async function GetHelperRegionMan(data = {}) {
	const res = await request.post("/api/helper/Helper/RegionMan", data);
	return res.data;
}

// 销售代表
export async function GetHelperSalesMan(data = {}) {
	const res = await request.post("/api/helper/Helper/SalesMan", data);
	return res.data;
}

// 医院列表
export async function GetHospitalList(data = {}) {
	const res = await request.post("/api/ba/Hospital/List", data);
	return res.data;
}

// 经销商
export async function GetCustomerList(data = {}) {
	const res = await request.post("/api/ba/Customer/List", data);
	return res.data;
}

// 渠道商业汇总数据
export async function GetSMSReportCustomerBusinessSummary(data = {}) {
	const res = await request.post(
		"/api/report/SMSReport/CustomerBusinessSummary",
		data
	);
	return res.data;
}

// 渠道商业历年销量
export async function GetSMSReportCustomerBusinessAmount(data = {}) {
	const res = await request.post(
		"/api/report/SMSReport/CustomerBusinessBySalesAmount",
		data
	);
	return res.data;
}

// 渠道L3销量趋势图
export async function GetSMSReportCustomerBusinessTendency(data = {}) {
	const res = await request.post(
		"/api/report/SMSReport/CustomerBusinessTendency",
		data
	);
	return res.data;
}

// 平台库存
export async function GetWMSReportStockForOrganization(data = {}) {
	const res = await request.post(
		"/api/report/WMSReport/CustomerStockForOrganization",
		data
	);
	return res.data;
}

// 经销商库存
export async function GetWMSReportStockForCustomer(data = {}) {
	const res = await request.post(
		"/api/report/WMSReport/CustomerStockForCustomer",
		data
	);
	return res.data;
}

// 库存透视数据
export async function GetStockPivotTable(data = {}) {
	const res = await request.post("/api/report/WMSReport/StockPivotTable", data);
	return res.data;
}

// 库存透视更多信息
export async function GetStockPivotTableDetail(data = {}) {
	const res = await request.post(
		"/api/report/WMSReport/StockPivotTableDetail",
		data
	);
	return res.data;
}

// 历史趋势图
export async function GetWMSReportCustomerStockTendency(data = {}) {
	const res = await request.post(
		"/api/report/WMSReport/CustomerStockTendency",
		data
	);
	return res.data;
}

// 获取证照是否完善
export async function GetLicenseRemindAuthorityLicense(data = {}) {
	const res = await request.post(
		"/api/ba/License/RemindAuthorityLicense",
		data
	);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns  指标默认分摊比例->列表
 */

export async function QuotaIMSRatioList(data = {}) {
	const res = await request.post("/api/ba/QuotaIMSRatio/List", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns  指标默认分摊比例->详情
 */

export async function QuotaIMSRatioInfo(data = {}) {
	const res = await request.post("/api/ba/QuotaIMSRatio/Info", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns  指标默认分摊比例->新增
 */

export async function QuotaIMSRatioAdd(data = {}) {
	const res = await request.post("/api/ba/QuotaIMSRatio/Add", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns  指标默认分摊比例->修改
 */

export async function QuotaIMSRatioEdit(data = {}) {
	const res = await request.post("/api/ba/QuotaIMSRatio/Edit", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns  出入库管理===>寄售订单
 */

export async function ConsignOrderList(data = {}) {
	const res = await request.post("/api/wms/ConsignOrder/List", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns  出入库管理===>寄售订单明细
 */

export async function ConsignOrderDetail(data = {}) {
	const res = await request.post("/api/wms/ConsignOrder/Detail", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns  出入库管理===>寄售订单===>导入模板下载
 */

export async function ConsignOrderDownloadTemplet(data = {}) {
	const res = await request.post("/api/wms/ConsignOrder/DownloadTemplet", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns  出入库管理===>寄售订单===>导入
 */

export async function ConsignOrderImport(data = {}) {
	const res = await request.post("/api/wms/ConsignOrder/Import", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns  出入库管理===>寄售订单===>审核
 */

export async function ConsignOrderVerify(data = {}) {
	const res = await request.post("/api/wms/ConsignOrder/Verify", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns  出入库管理===>寄售订单===>弃审
 */

export async function ConsignOrderUnVerify(data = {}) {
	const res = await request.post("/api/wms/ConsignOrder/UnVerify", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns  出入库管理===>寄售订单===>删除
 */

export async function ConsignOrderDelete(data = {}) {
	const res = await request.post("/api/wms/ConsignOrder/Delete", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns  出入库管理===>寄售订单===>导出
 */

export async function ConsignOrderExport(data = {}) {
	const res = await request.post("/api/wms/ConsignOrder/Export", data, {
		responseType: "blob",
	});
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns  出入库管理===>寄售订单===>新增出库单====>新增
 */

export async function ConsignOrderAdd(data = {}) {
	const res = await request.post("/api/wms/ConsignOrder/Add", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns  出入库管理===>寄售订单===>新增出库单====>编辑
 */

export async function ConsignOrderEdit(data = {}) {
	const res = await request.post("/api/wms/ConsignOrder/Edit", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns  出入库管理===>寄售订单详情
 */

export async function ConsignOrderInfo(data = {}) {
	const res = await request.post("/api/wms/ConsignOrder/Info", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns  出入库管理===>寄售订单===>新增出库单====>导入模板下载
 */

export async function ConsignOrderDownloadDetailTemplet(data = {}) {
	const res = await request.post(
		"/api/wms/ConsignOrder/DownloadDetailTemplet",
		data
	);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns  出入库管理===>寄售订单===>新增出库单====>导入
 */

export async function ConsignOrderImportDetail(data = {}) {
	const res = await request.post("/api/wms/ConsignOrder/ImportDetail", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns  基础档案管理===>价格===>价格配置====>价格形式
 */

export async function GetHelperCostType(data = {}) {
	const res = await request.get("/api/helper/Helper/CostType", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns  基础档案管理===>价格===>价格配置====>价格列表数树
 */

export async function GetCostSettingListByTree(data = {}) {
	const res = await request.post("/api/ba/CostSetting/ListByTree", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns  基础档案管理===>价格===>价格配置====>上级类型
 */

export async function GetCostSettingListParent(data = {}) {
	const res = await request.post("/api/ba/CostSetting/ListParent", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns  基础档案管理===>价格===>价格配置====>节点类型
 */

export async function GetHelperNodeType(data = {}) {
	const res = await request.get("/api/helper/Helper/NodeType", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns  基础档案管理===>价格===>价格配置====>详情
 */

export async function InfoCostSettingData(data = {}) {
	const res = await request.post("/api/ba/CostSetting/Info", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns  基础档案管理===>价格===>价格配置====>新增
 */

export async function AddCostSettingData(data = {}) {
	const res = await request.post("/api/ba/CostSetting/Add", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns  基础档案管理===>价格===>价格配置====>编辑
 */

export async function EditCostSettingData(data = {}) {
	const res = await request.post("/api/ba/CostSetting/Edit", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns  基础档案管理===>价格===>价格配置====>删除
 */

export async function DeleteCostSettingData(data = {}) {
	const res = await request.post("/api/ba/CostSetting/Delete", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns  基础档案管理===>价格===>价格配置====>新增产品范围
 */

export async function GetHelperLEVEL134(data = {}) {
	const res = await request.post("/api/helper/Helper/LEVEL134", data);
	return res.data;
}


/**
 *
 * @param {*} data
 * @returns 省
 */
export async function GetProvince(data = {}) {
	const res = await request.get(
		"/api/helper/Region/GetProvinceWithCountry",
		data
	);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 市
 */
export async function GetCity(params = {}) {
	const res = await request.get("/api/helper/Region/GetCity", params);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 区
 */
export async function GetDistrict(data = {}) {
	const res = await request.get("/api/helper/Region/GetDistrict", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns  基础档案管理===>价格===>价格配置====>新增经销商范围
 */

export async function AddCostSettingCustomer(data = {}, code) {
	const res = await request.post(
		`/api/ba/CostSetting/AddCustomer?csmid=${code}`,
		data
	);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns  基础档案管理===>价格===>价格配置====>移除经销商范围
 */

export async function RemoveCostSettingCustomer(data = {}) {
	const res = await request.post("/api/ba/CostSetting/RemoveCustomer", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns  基础档案管理===>价格===>价格配置====>新增医院范围
 */

export async function AddCostSettingHospital(data = {}, code) {
	const res = await request.post(
		`/api/ba/CostSetting/AddHospital?csmid=${code}`,
		data
	);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns  基础档案管理===>价格===>价格配置====>移除医院范围
 */

export async function RemoveCostSettingHospital(data = {}) {
	const res = await request.post("/api/ba/CostSetting/RemoveHospital", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns  基础档案管理===>价格===>价格汇总====>列表
 */

export async function GetCostSummaryList(data = {}) {
	const res = await request.post("/api/ba/CostSummary/List", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns  基础档案管理===>价格===>价格汇总====>详情
 */

export async function InfoCostSummary(data = {}) {
	const res = await request.post("/api/ba/CostSummary/Info", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns  基础档案管理===>价格===>价格汇总====>编辑
 */

export async function EditCostSummary(data = {}) {
	const res = await request.post("/api/ba/CostSummary/Edit", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns  基础档案管理===>价格===>价格汇总====>删除
 */

export async function DeleteCostSummary(data = {}) {
	const res = await request.post("/api/ba/CostSummary/Delete", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns  基础档案管理===>价格===>价格汇总====>经销商
 */

export async function CostSettingCustomerList(data = {}) {
	const res = await request.post("/api/ba/CostSetting/CustomerList", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns  基础档案管理===>价格===>价格汇总====>医院
 */

export async function CostSettingHospitalList(data = {}) {
	const res = await request.post("/api/ba/CostSetting/HospitalList", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 基础档案管理===>价格===>价格配置====>下载
 */
export async function CostSettingDownloadDetailTemplet(data = {}) {
	const res = await request.post(
		"/api/ba/CostSetting/DownloadDetailTemplet",
		data
	);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 基础档案管理===>价格===>价格配置====>导入
 */
export async function CostSettingImportDetail(data = {}) {
	const res = await request.post("/api/ba/CostSetting/ImportDetail", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns  基础档案管理===>价格===>价格配置====>移除经销商范围数据
 */

export async function RemoveAllCustomer(data = {}) {
	const res = await request.post("/api/ba/CostSetting/RemoveAllCustomer", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns  基础档案管理===>价格===>价格配置====>移除医院范围数据
 */

export async function RemoveAllHospital(data = {}) {
	const res = await request.post("/api/ba/CostSetting/RemoveAllHospital", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns  基础档案管理===>价格===>价格汇总====>导出
 */

export async function ExportCostSummary(data = {}) {
	const res = await request.post("/api/ba/CostSummary/Export", data, {
		responseType: "blob",
	});
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns  出入库管理===>经销商库存对账===>仓库下拉
 */

export async function GetWarehouseForCheckVouch(data = {}) {
	const res = await request.post(
		"/api/wms/CheckVouch/GetWarehouseForCheckVouch",
		data
	);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns  出入库管理===>经销商库存对账===>列表
 */

export async function GetCheckVouchList(data = {}) {
	const res = await request.post("/api/wms/CheckVouch/GetDetail", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns  出入库管理===>经销商库存对账===>下载导入模板
 */

export async function DownloadTempletCheckVouch(data = {}) {
	const res = await request.post("/api/wms/CheckVouch/DownloadTemplet", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns  出入库管理===>经销商库存对账===>导入数据
 */

export async function ImportCheckVouch(data = {}, cusCode, cvmid) {
	const res = await request.post(`/api/wms/CheckVouch/Import?CusCode=${cusCode}&cvmid=${cvmid}`, data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns  出入库管理===>经销商库存对账===>补充导入
 */

export async function ImportReplenish(data = {}, cusCode, cvmid) {
	const res = await request.post(`/api/wms/CheckVouch/ImportReplenish?CusCode=${cusCode}&cvmid=${cvmid}`, data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns  出入库管理===>经销商库存对账===>保存
 */

export async function EditCheckVouch(data = {}, CVMID) {
	const res = await request.post(`/api/wms/CheckVouch/Edit?CVMID=${CVMID}`, data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns  出入库管理===>经销商库存对账===>提交
 */

export async function SubmitCheckVouch(data = {}, cusCode) {
	const res = await request.post(`/api/wms/CheckVouch/Submit?CusCode=${cusCode}`, data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns  出入库管理===>经销商库存对账===>撤回
 */

export async function CancelCheckVouch(data = {}, cusCode) {
	const res = await request.post(`/api/wms/CheckVouch/Cancel?CusCode=${cusCode}`, data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns  出入库管理===>经销商库存对账===>清空
 */

export async function DeleteCheckVouch(data = {}, cusCode) {
	const res = await request.post(`/api/wms/CheckVouch/Delete?CusCode=${cusCode}`, data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns  出入库管理===>经销商库存对账===>删除唯一码明细
 */
export async function DelUniqueCheckVouch(data = {}) {
	const res = await request.post("/api/wms/CheckVouch/DelUnique", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns  出入库管理===>经销商库存对账===>调整库存===>状态下拉
 */

export async function GetHelperOrderStatus(data = {}) {
	const res = await request.get("/api/helper/Helper/OrderStatus", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns  出入库管理===>经销商库存对账===>调整库存===>列表
 */

export async function GetCheckVouchDataList(data = {}) {
	const res = await request.post("/api/wms/CheckVouch/List", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns  出入库管理===>经销商库存对账===>调整库存===>确认
 */

export async function VerifyCheckVouch(data = {}) {
	const res = await request.post("/api/wms/CheckVouch/Verify", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns  出入库管理===>经销商库存对账===>调整库存===>弃审
 */

export async function UnVerifyCheckVouch(data = {}) {
	const res = await request.post("/api/wms/CheckVouch/UnVerify", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns  出入库管理===>经销商库存对账===>调整库存===>驳回
 */

export async function RejectCheckVouch(data = {}) {
	const res = await request.post("/api/wms/CheckVouch/Reject", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns  出入库管理===>经销商库存对账===>调整库存===>导出
 */

export async function ExportCheckVouch(data = {}) {
	const res = await request.post("/api/wms/CheckVouch/Export", data, {
		responseType: "blob",
	});
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns  出入库管理===>经销商库存对账===>调整库存===>明细导出
 */

export async function DetailExportCheckVouch(data = {}) {
	const res = await request.post("/api/wms/CheckVouch/DetailExport", data, {
		responseType: "blob",
	});
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 获取列表
 */

export async function GetInventoryList(data = {}) {
	const res = await request.post("/api/ba/Inventory/List", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 医院IMS月度导入
 */

export async function ImportQuotaIMSYear(data = {}) {
	const res = await request.post("/api/ba/QuotaIMSYear/ImportMonth", data, {
		headers: {
			"Content-Type": "multipart/form-data;",
		},
	});
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 内部指标月度导入
 */
export async function ImportQuotaInnerYear(data = {}) {
	const res = await request.post("/api/ba/QuotaInnerYear/ImportMonth", data, {
		headers: {
			"Content-Type": "multipart/form-data;",
		},
	});
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 内部指标月度导入
 */
export async function ProvinceASNRanking(data = {}) {
	const res = await request.post("/api/report/QuotaReport/ProvinceASNRanking", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 二级经销商管理档案-列表
 */
export async function GetCusRelationCustomerList(data = {}) {
	const res = await request.post("/api/ba/CusRelationCustomer/List", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 二级经销商管理档案-详情
 */
export async function GetCusRelationCustomerInfo(data = {}) {
	const res = await request.post("/api/ba/CusRelationCustomer/Info", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 二级经销商管理档案-附件上传
 */
export async function UploadAttachmentByEdit(data = {}) {
	const res = await request.post(
		"/api/ba/CusRelationCustomer/UploadAttachmentByEdit",
		data
	);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 二级经销商管理档案-新增
 */
export async function AddCusRelationCustomer(data = {}) {
	const res = await request.post("/api/ba/CusRelationCustomer/Add", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 二级经销商管理档案-启用
 */
export async function ActiveCusRelationCustomer(data = {}) {
	const res = await request.post("/api/ba/CusRelationCustomer/Active", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 二级经销商管理档案-停用
 */
export async function DeactiveCusRelationCustomer(data = {}) {
	const res = await request.post("/api/ba/CusRelationCustomer/Deactive", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 二级经销商管理档案-上传文件
 */
export async function UploadAttachmentCusRelationCustomer(IDs, data = {}) {
	const res = await request.post(
		"/api/ba/CusRelationCustomer/UploadAttachment?IDs=" + IDs,
		data
	);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 二级经销商管理档案-导出
 */
export async function ExportCusRelationCustomer(data = {}) {
	const res = await request.post("/api/ba/CusRelationCustomer/Export", data, {
		responseType: "blob",
	});
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 二级经销商管理档案-导入模板下载
 */
export async function DownloadCusRelationCustomer(data = {}) {
	const res = await request.post(
		"/api/ba/CusRelationCustomer/DownloadTemplet",
		data
	);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 二级经销商管理档案-导入
 */
export async function ImportCusRelationCustomer(data = {}) {
	const res = await request.post("/api/ba/CusRelationCustomer/Import", data);
	return res.data;
}




/**
 *
 * @param {*} data
 * @returns 历年经销商评分-列表
 */
export async function GetCustomerScoreList(data = {}) {
	const res = await request.post("/api/ba/CustomerScore/List", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 历年经销商评分-详情
 */
export async function GetCustomerScoreInfo(data = {}) {
	const res = await request.post("/api/ba/CustomerScore/Info", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 历年经销商评分-导出
 */
export async function ExportCustomerScore(data = {}) {
	const res = await request.post("/api/ba/CustomerScore/Export", data, {
		responseType: "blob",
	});
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 历年经销商评分-导入模板下载
 */
export async function DownloadTempletCustomerScore(data = {}) {
	const res = await request.post("/api/ba/CustomerScore/DownloadTemplet", data);
	return res.data;
}


/**
 *
 * @param {*} data
 * @returns 历年经销商评分-导入
 */
export async function ImportCustomerScore(data = {}) {
	const res = await request.post("/api/ba/CustomerScore/Import", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 历年经销商评分-新增
 */
export async function AddCustomerScore(data = {}) {
	const res = await request.post("/api/ba/CustomerScore/Add", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 历年经销商评分-修改
 */
export async function EditCustomerScore(data = {}) {
	const res = await request.post("/api/ba/CustomerScore/Edit", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 历年经销商评分-删除
 */
export async function DelCustomerScore(data = {}) {
	const res = await request.post("/api/ba/CustomerScore/Delete", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 省份关闭产品列表
 */
export async function GetInventoryProvinceList(data = {}) {
	const res = await request.post("/api/ba/InventoryProvince/List", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 省份列表
 */
export async function GetProvinceRegion(data = {}) {
	const res = await request.get("/api/helper/Region/GetProvince", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 导出省份数据
 */
export async function ExportInventoryProvince(data = {}) {
	const res = await request.post("/api/ba/InventoryProvince/Export", data, {
		responseType: "blob",
	});
	return res.data;
}


/**
 *
 * @param {*} data
 * @returns 导入模板下载
 */
export async function DownloadInventoryProvince(data = {}) {
	const res = await request.post("/api/ba/InventoryProvince/DownloadTemplet", data);
	return res.data;
}


/**
 *
 * @param {*} data
 * @returns 导入数据
 */
export async function ImportInventoryProvince(data = {}) {
	const res = await request.post("/api/ba/InventoryProvince/Import", data);
	return res.data;
}


/**
 *
 * @param {*} data
 * @returns 查询绑定数据
 */
export async function ListForEditInventoryProvince(data = {}) {
	const res = await request.post("/api/ba/InventoryProvince/ListForEdit", data);
	return res.data;
}


/**
 *
 * @param {*} data
 * @returns 保存数据
 */
export async function EditInventoryProvince(data = {}) {
	const res = await request.post("/api/ba/InventoryProvince/Edit", data);
	return res.data;
}


/**
 *
 * @param {*} data
 * @returns 全部关联
 */
export async function AllRelateInventoryProvince(data = {}) {
	const res = await request.post("/api/ba/InventoryProvince/AllRelate", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 全部取消
 */
export async function AllCancelInventoryProvince(data = {}) {
	const res = await request.post("/api/ba/InventoryProvince/AllCancel", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 条件关联
 */
export async function ConditionRelateInventoryProvince(data = {}) {
	const res = await request.post("/api/ba/InventoryProvince/ConditionRelate", data);
	return res.data;
}


/**
 *
 * @param {*} data
 * @returns 条件取消
 */
export async function ConditionCancelInventoryProvince(data = {}) {
	const res = await request.post("/api/ba/InventoryProvince/ConditionCancel", data);
	return res.data;
}


/**
 *计量单位转换
 *
 */


/**
 *
 * @param {*} data
 * @returns 列表
 */
export async function GetUnitConvertList(data = {}) {
	const res = await request.post("/api/ba/UnitConvert/List", data);
	return res.data;
}


/**
 *
 * @param {*} data
 * @returns 导出
 */
export async function ExportUnitConvert(data = {}) {
	const res = await request.post("/api/ba/UnitConvert/Export", data, {
		responseType: "blob",
	});
	return res.data;
}


/**
 *
 * @param {*} data
 * @returns 导入模板下载
 */
export async function DownTempUnitConvert(data = {}) {
	const res = await request.post("/api/ba/UnitConvert/DownloadTemplet", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 新增
 */
export async function AddUnitConvert(data = {}) {
	const res = await request.post("/api/ba/UnitConvert/Add", data);
	return res.data;
}


/**
 *
 * @param {*} data
 * @returns 编辑
 */
export async function EditUnitConvert(data = {}) {
	const res = await request.post("/api/ba/UnitConvert/Edit", data);
	return res.data;
}


/**
 *
 * @param {*} data
 * @returns 详情
 */
export async function GetUnitConvertInfo(data = {}) {
	const res = await request.post("/api/ba/UnitConvert/Info", data);
	return res.data;
}


/**
 *
 * @param {*} data
 * @returns 删除
 */
export async function DeleteUnitConvert(data = {}) {
	const res = await request.post("/api/ba/UnitConvert/Delete", data);
	return res.data;
}


/**
 *
 * @param {*} data
 * @returns 导入
 */
export async function ImportUnitConvert(data = {}) {
	const res = await request.post("/api/ba/UnitConvert/Import", data);
	return res.data;
}


/**
 *
 * @param {*} data
 * @returns 获取产品
 */
export async function GetInventoryByAddCode(data = {}) {
	const res = await request.post("/api/ba/Inventory/InfoByAddCode", data);
	return res.data;
}



/**
 *
 * @param {*} data
 * @returns 添加盘点任务
 */
export async function AddScanCheckVouch(data = {}) {
	const res = await request.post("/api/scan/CheckVouch/Add", data);
	return res.data;
}



/**
 *
 * @param {*} data
 * @returns 获取唯一码详情
 */
export async function GetUniqueDetail(data = {}) {
	const res = await request.post("/api/wms/CheckVouch/GetUniqueDetail", data);
	return res.data;
}


/**
 *
 * @param {*} data
 * @returns 获取经销商下拉列表
 */
export async function GetOrderCustomer(data = {}) {
	const res = await request.post("/api/common/Helper/GetOrderCustomer", data);
	return res.data;
}

/**
 * 
 * @param {*} data
 * @returns LEVEL树列表
 */
export async function GetLEVELList(data = {}) {
	const res = await request.post("/api/ba/LEVEL/List", data);
	return res.data;
}

/**
 * 
 * @param {*} data
 * @returns LEVEL导出
 */
export async function ExportLEVEL(data = {}) {
	const res = await request.post("/api/ba/LEVEL/Export", data, {
		responseType: 'blob'
	});
	return res.data;
}

/**
 * 
 * @param {*} data
 * @returns LEVEL新增
 */
export async function AddLEVEL(data = {}) {
	const res = await request.post("/api/ba/LEVEL/Add", data);
	return res.data;
}

/**
 * 
 * @param {*} data
 * @returns LEVEL修改
 */
export async function EditLEVEL(data = {}) {
	const res = await request.post("/api/ba/LEVEL/Edit", data);
	return res.data;
}

/**
 * 
 * @param {*} data
 * @returns LEVEL删除
 */
export async function DeleteLEVEL(data = {}) {
	const res = await request.post("/api/ba/LEVEL/Delete", data);
	return res.data;
}

/**
 * 
 * @param {*} data
 * @returns 组织NTS配额列表
 */
export async function GetOrganizationNTSQuotaList(data = {}) {
	const res = await request.post("/api/ba/OrganizationNTSQuota/List", data);
	return res.data;
}

/**
 * 
 * @param {*} data
 * @returns 组织NTS配额详情
 */
export async function GetOrganizationNTSQuotaInfo(data = {}) {
	const res = await request.post("/api/ba/OrganizationNTSQuota/Info", data);
	return res.data;
}

/**
 * 
 * @param {*} data
 * @returns 组织NTS配额导出
 */
export async function ExportOrganizationNTSQuota(data = {}) {
	const res = await request.post("/api/ba/OrganizationNTSQuota/Export", data, {
		responseType: 'blob'
	});
	return res.data;
}

/**
 * 
 * @param {*} data
 * @returns 组织NTS配额新增
 */
export async function AddOrganizationNTSQuota(data = {}) {
	const res = await request.post("/api/ba/OrganizationNTSQuota/Add", data);
	return res.data;
}

/**
 * 
 * @param {*} data
 * @returns 组织NTS配额修改
 */
export async function EditOrganizationNTSQuota(data = {}) {
	const res = await request.post("/api/ba/OrganizationNTSQuota/Edit", data);
	return res.data;
}

/**
 * 
 * @param {*} data
 * @returns 组织NTS配额删除
 */
export async function DeleteOrganizationNTSQuota(data = {}) {
	const res = await request.post("/api/ba/OrganizationNTSQuota/Delete", data);
	return res.data;
}

/**
 * 
 * @param {*} data
 * @returns 组织NTS配额导入模板下载
 */
export async function DownloadOrganizationNTSQuotaTemplet(data = {}) {
	const res = await request.post("/api/ba/OrganizationNTSQuota/DownloadTemplet", data);
	return res.data;
}

/**
 * 
 * @param {*} data
 * @returns 组织NTS配额导入
 */
export async function ImportOrganizationNTSQuota(data = {}) {
	const res = await request.post("/api/ba/OrganizationNTSQuota/Import", data, {
		headers: {
			"Content-Type": "multipart/form-data;",
		},
	});
	return res.data;
}



/**
 *
 * @param {*} data
 * @returns 下载唯一码库存上报模板
 */
export async function DownStockByCustomer(data = {}) {
	const res = await request.post("/api/wms/StockByCustomer/DownloadTemplet", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 获取唯一码库存上报列表
 */
export async function GetStockByCustomerList(data = {}) {
	const res = await request.post("/api/wms/StockByCustomer/List", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 获取唯一码库存上报列表
 */
export async function ExportStockByCustomer(data = {}) {
	const res = await request.post("/api/wms/StockByCustomer/Export", data, {
		responseType: 'blob'
	});
	return res.data;
}


/**
 *
 * @param {*} data
 * @returns 导入唯一码库存上报列表
 */
export async function ImportStockByCustomer(data = {}) {
	const res = await request.post("/api/wms/StockByCustomer/Import", data);
	return res.data;
}



/**
 *
 * @param {*} data
 * @returns 获取库存唯一码上报（接口版）列表
 */
export async function GetUniqueStockByCustomerList(data = {}) {
	const res = await request.post("/api/wms/UniqueStockByCustomer/List", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 获取库存唯一码上报（接口版）经销商下拉框
 */
export async function GetUniqueStockOrganizationList(data = {}) {
	const res = await request.post("/api/helper/Helper/UniqueStockOrganizationList", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 获取库存唯一码上报（接口版）导出
 */
export async function ExportUniqueStockByCustomer(data = {}) {
	const res = await request.post("/api/wms/UniqueStockByCustomer/Export", data, {
		responseType: 'blob'
	});
	return res.data;
}


/**
 *
 * @param {*} data
 * @returns 获取库存唯一码上报（接口版）刷新
 */
export async function RefreshUniqueStock(data = {}) {
	const res = await request.get(`/api/wms/UniqueStockByCustomer/RefreshUniqueStock?CompanyID=${data.CompanyID}`,
		data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 历史盖章文件
 */
export async function CustomerQuotaHistoryList(data = {}) {
	const res = await request.post("/api/ba/CustomerQuotaHistory/List", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 历史盖章文件-导出
 */
export async function ExportCustomerQuotaHistory(data = {}) {
	const res = await request.post("/api/ba/CustomerQuotaHistory/Export", data, {
		responseType: 'blob'
	});
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 历史盖章文件-导出
 */
export async function GeneratePdfCustomerQuotaHistory(data = {}) {
	const res = await request.post("/api/ba/CustomerQuotaHistory/GeneratePdf", data, {
		responseType: 'blob'
	});
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 数据管理->报表->列表->经销商医院授权列表
 */
export async function GetAuthorityHospitalList(data = {}) {
	const res = await request.post("/api/ba/AuthorityHospital/List", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 数据管理->报表->列表->经销商医院授权列表导出
 */
export async function ExportAuthorityHospital(data = {}) {
	const res = await request.post("/api/ba/AuthorityHospital/Export", data, {
		responseType: 'blob'
	});
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 数据管理->报表->业务透视->渠道库存->新模式平台库存
 */
export async function GetOrgConsignmentStock(data = {}) {
	const res = await request.post("/api/report/WMSReport/OrgConsignmentStock", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 数据管理->报表->业务透视->渠道库存->新模式平台库存->详情
 */
export async function GetOrgConsignmentStockDetail(data = {}) {
	const res = await request.post("/api/report/WMSReport/OrgConsignmentStockDetail", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 刷新NTS季度达成率数据
 * @description 入参：{Year: 年份, AccType: 渠道类型(U8/U9)}
 */
export async function RefreshNTSQuarterAchievingRate(data = {}) {
	const res = await request.post("/api/report/U8Report/RefreshNTSQuarterAchievingRate", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 获取NTS季度达成率数据
 * @description 入参：{Year: 年份, AccType: 渠道类型(U8/U9)}
 */
export async function GetNTSQuarterAchievingRate(data = {}) {
	const res = await request.post("/api/report/U8Report/NTSQuarterAchievingRate", data);
	return res.data;
}

/**
 * 获取NTS季度达成率列表数据
 * @param {*} data
 */
export async function GetNTSQuarterAchievingRateList(data = {}) {
	const res = await request.post("/api/report/U8Report/NTSQuarterAchievingRateList", data);
	return res.data;
}

/**
 * 导出NTS季度达成率列表数据
 * @param {*} data
 */
export async function ExportNTSQuarterAchievingRateList(data = {}) {
	const res = await request.post("/api/report/U8Report/NTSQuarterAchievingRateExport", data, {
		responseType: "blob",
	});
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 刷新NTS平均价格数据
 * @description 入参：{Year: 年份, AccType: 渠道类型(U8/U9), InvClass: 产品线, InvName: 产品名称}
 */
export async function RefreshNTSAveragePrice(data = {}) {
	const res = await request.post("/api/report/U8Report/RefreshNTSAveragePrice", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 获取NTS平均价格数据
 * @description 入参：{Year: 年份, AccType: 渠道类型(U8/U9), InvClass: 产品线, InvName: 产品名称}
 */
export async function GetNTSAveragePrice(data = {}) {
	const res = await request.post("/api/report/U8Report/NTSAveragePrice", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 导出NTS平均价格数据
 * @description 入参：{Year: 年份, AccType: 渠道类型(U8/U9), InvClass: 产品线, InvName: 产品名称, LEVEL2, LEVEL3, MinMonth, MaxMonth}
 */
export async function ExportNTSAveragePrice(data = {}) {
	const res = await request.post("/api/report/U8Report/NTSAveragePriceExport", data, {
		responseType: "blob",
	});
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 获取产品名称列表
 * @description 入参：{InvClass: 产品线, InvName: 产品名称}
 */
export async function GetInvNameList(data = {}) {
	const res = await request.post("/api/helper/Helper/InvName", data);
	return res.data;
}


/**
 *
 * @param {*} data
 * @returns 数据管理->报表->业务透视->终端统计->植入家数
 */
export async function GetIMSHospitalCount(data = {}) {
	const res = await request.post("/api/report/SMSReport/IMSHospitalCount", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 数据管理->报表->业务透视->终端统计->授权家数
 */
export async function GetAuthorityHospitalCount(data = {}) {
	const res = await request.post("/api/report/BAReport/AuthorityHospitalCount", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 数据管理->报表->业务透视->终端统计->LEVEL3植入授权数量
 */
export async function GetLEVEL3HospitalCount(data = {}) {
	const res = await request.post("/api/report/SMSReport/LEVEL3HospitalCount", data);
	return res.data;
}


/**
 *
 * @param {*} data
 * @returns 数据管理->出入库-->空转
 */
export async function GetEmptySalesList(data = {}) {
	const res = await request.post("/api/sms/EmptySales/List", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 数据管理->出入库-->空转-->导出
 */
export async function ExportEmptySales(data = {}) {
	const res = await request.post("/api/sms/EmptySales/Export", data, {
		responseType: 'blob'
	});
	return res.data;
}


/**
 *
 * @param {*} data
 * @returns 数据管理->出入库-->空转-->批量删除
 */
export async function DeleteEmptySales(data = {}) {
	const res = await request.post("/api/sms/EmptySales/Delete", data);
	return res.data;
}


/**
 *
 * @param {*} data
 * @returns 数据管理->报表-->列表-->平台库存天数
 */
export async function GetOrgStockDayByInvAddCode(data = {}) {
	const res = await request.post("/api/report/WMSReport/OrgStockDayByInvAddCode", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 数据管理->报表-->列表-->导出
 */
export async function ExportOrgStockDayByInvAddCode(data = {}) {
	const res = await request.post("/api/report/WMSReport/OrgStockDayByInvAddCodeExport", data, {
		responseType: "blob",
	});
	return res.data;
}


/**
 *
 * @param {*} data
 * @returns 工作日常->经销商指标->加价率调整->含税指标系数设置-查询
 */
export async function GetSetMarkupRate(data = {}) {
	const res = await request.post("/api/ba/QuotaCustomerVerify/GetSetMarkupRate", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 工作日常->经销商指标->加价率调整->含税指标系数设置-添加
 */
export async function SetMarkupRate(data = {}) {
	const res = await request.post("/api/ba/QuotaCustomerVerify/SetMarkupRate", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 工作日常->经销商指标->指标申请->加价率文案查询
 */
export async function GetMarkupRateInfo(data = {}) {
	const res = await request.post("/api/ba/QuotaCustomerVerify/GetMarkupRateInfo", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 工作日常->经销商指标->指标申请->批量修改加价率
 */
export async function BatchEdit(data = {}) {
	const res = await request.post("/api/ba/QuotaCustomerVerify/BatchEdit", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 出入库管理->经销商对账->留言列表
 */
export async function GetMessageCheckVouch(data = {}) {
	const res = await request.post("/api/wms/CheckVouch/GetMessage", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 修改经销商对账标题
 */
export async function EditCheckVouchTitle(data = {}) {
	const res = await request.post("/api/wms/CheckVouch/EditTitle", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 出入库管理->经销商对账->发布留言
 */
export async function AddMessageCheckVouch(data = {}) {
	const res = await request.post("/api/wms/CheckVouch/AddMessage", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 出入库管理->经销商对账->已读留言
 */
export async function ReadBoardCheckVouch(data = {}) {
	const res = await request.post("/api/wms/CheckVouch/ReadBoard", data);
	return res.data;
}


/**
 *
 * @param {*} data
 * @returns 出入库管理->空转->行详情
 */
export async function GetEmptySalesDetail(data = {}) {
	const res = await request.post("/api/sms/EmptySales/Detail", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 报表->业务透视->终端统计
 */
export async function GetZyloxHospitalCountByTendency(data = {}) {
	const res = await request.post("/api/report/SMSReport/ZyloxHospitalCountByTendency", data);
	return res.data;
}


/**
 *
 * @param {*} data
 * @returns 日常工作->样品管理->样品汇总
 */
export async function GetSampleList(data = {}) {
	const res = await request.post("/api/ba/SampleList/List", data);
	return res.data;
}


/**
 *
 * @param {*} data
 * @returns 日常工作->样品管理->申请样品->列表
 */
export async function GetAPPSampleList(data = {}) {
	const res = await request.post("/api/ba/APPSample/List", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 日常工作->样品管理->申请样品->详情
 */
export async function GetAPPSampleInfo(data = {}) {
	const res = await request.post("/api/ba/APPSample/Info", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 日常工作->样品管理->申请样品->导入模板下载
 */
export async function DownAPPSampleTemp(data = {}) {
	const res = await request.post("/api/ba/APPSample/DownloadTemplet", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 日常工作->样品管理->申请样品->新增
 */
export async function AddAPPSampleData(data = {}) {
	const res = await request.post("/api/ba/APPSample/Add", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 日常工作->样品管理->申请样品->编辑
 */
export async function EditAPPSampleData(data = {}) {
	const res = await request.post("/api/ba/APPSample/Edit", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 日常工作->样品管理->申请样品->导出
 */
export async function ExportAPPSampleData(data = {}) {
	const res = await request.post("/api/ba/APPSample/Export", data, {
		responseType: 'blob'
	});
	return res.data;
}


/**
 *
 * @param {*} data
 * @returns 日常工作->样品管理->申请样品->导入
 */
export async function ImportAPPSampleData(data = {}) {
	const res = await request.post("/api/ba/APPSample/Import", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 日常工作->样品管理->申请样品->删除
 */
export async function DeleteAPPSampleData(data = {}) {
	const res = await request.post("/api/ba/APPSample/Delete", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 日常工作->样品管理->申请样品->提交
 */
export async function SubmitAPPSampleData(data = {}) {
	const res = await request.post("/api/ba/APPSample/Submit", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 日常工作->样品管理->申请样品->撤回
 */
export async function RevokeAPPSampleData(data = {}) {
	const res = await request.post("/api/ba/APPSample/Revoke", data);
	return res.data;
}


/**
 *
 * @param {*} data
 * @returns 日常工作->样品管理->申请样品->审批
 */
export async function ApproveAPPSampleData(data = {}) {
	const res = await request.post("/api/ba/APPSample/Approve", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 日常工作->样品管理->申请样品->驳回审批
 */
export async function RejectAPPSampleData(data = {}) {
	const res = await request.post("/api/ba/APPSample/Reject", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 日常工作->样品管理->申请样品->审批流程
 */
export async function GetHostoryAPPSampleData(data = {}) {
	const res = await request.post("/api/ba/APPSample/GetHostory", data);
	return res.data;
}


/**
 *
 * @param {*} data
 * @returns 日常工作->样品管理->申请样品->明细
 */
export async function DetailAPPSampleData(data = {}) {
	const res = await request.post("/api/ba/APPSample/Detail", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 日常工作->样品管理->样品列表->导出
 */
export async function ExportSampleListData(data = {}) {
	const res = await request.post("/api/ba/SampleList/Export", data, {
		responseType: 'blob'
	});
	return res.data;
}

/**
 * 
 * @param {*} data
 * @returns 组织返利列表
 */
export async function GetOrganizationRebateList(data = {}) {
	const res = await request.post("/api/ba/OrganizationRebate/List", data);
	return res.data;
}

/**
 * 
 * @param {*} data
 * @returns 组织返利详情
 */
export async function GetOrganizationRebateInfo(data = {}) {
	const res = await request.post("/api/ba/OrganizationRebate/Info", data);
	return res.data;
}

/**
 * 
 * @param {*} data
 * @returns 组织返利导出
 */
export async function ExportOrganizationRebate(data = {}) {
	const res = await request.post("/api/ba/OrganizationRebate/Export", data, {
		responseType: 'blob'
	});
	return res.data;
}

/**
 * 
 * @param {*} data
 * @returns 组织返利新增
 */
export async function AddOrganizationRebate(data = {}) {
	const res = await request.post("/api/ba/OrganizationRebate/Add", data);
	return res.data;
}

/**
 * 
 * @param {*} data
 * @returns 组织返利修改
 */
export async function EditOrganizationRebate(data = {}) {
	const res = await request.post("/api/ba/OrganizationRebate/Edit", data);
	return res.data;
}

/**
 * 
 * @param {*} data
 * @returns 组织返利删除
 */
export async function DeleteOrganizationRebate(data = {}) {
	const res = await request.post("/api/ba/OrganizationRebate/Delete", data);
	return res.data;
}

/**
 * 
 * @param {*} data
 * @returns 组织返利导入模板下载
 */
export async function DownloadOrganizationRebateTemplet(data = {}) {
	const res = await request.post("/api/ba/OrganizationRebate/DownloadTemplet", data);
	return res.data;
}

/**
 * 
 * @param {*} data
 * @returns 组织返利导入
 */
export async function ImportOrganizationRebate(data = {}) {
	const res = await request.post("/api/ba/OrganizationRebate/Import", data);
	return res.data;
}

/**
 * 
 * @param {*} data
 * @returns 获取产品线
 */
export async function GetHelperProductLine(data = {}) {
	const res = await request.post("/api/helper/Helper/ProductLine", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 基础档案->价格->价格配置->启用
 */
export async function ActivedCostSetting(data = {}) {
	const res = await request.post("/api/ba/CostSetting/Actived", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 基础档案->价格->价格配置->禁用
 */
export async function DisabledCostSetting(data = {}) {
	const res = await request.post("/api/ba/CostSetting/Disabled", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 日常工作->样品管理->样品申请->上传文件
 */
export async function UpLoadAttachments(data = {}, AppID = '') {
	const res = await request.post(`/api/ba/APPSample/UpLoadAttachments?AppID=${AppID}`, data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 日常工作->样品管理->样品申请->附件列表
 */
export async function GetAttatchments(data = {}) {
	const res = await request.post(`/api/ba/APPSample/Attatchments`, data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 日常工作->样品管理->样品申请->删除附件
 */
export async function DeleteAttatchment(data = {}) {
	const res = await request.post(`/api/ba/APPSample/DeleteAttatchment`, data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 日常工作->样品管理->样品申请->样品类型搜索下拉
 */
export async function GetHelperSampleTypeForSearch(data = {}) {
	const res = await request.get(`/api/helper/Helper/SampleTypeForSearch`, data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 日常工作->样品管理->样品申请->样品类型下拉
 */
export async function GetHelperSampleType(data = {}) {
	const res = await request.get(`/api/helper/Helper/SampleType`, data);
	return res.data;
}


/**
 *
 * @param {*} data
 * @returns 基础档案->价格->价格配置->导入模板下载
 */
export async function DownloadRangeSettingTemplet(data = {}) {
	const res = await request.post(`/api/ba/CostSetting/DownloadRangeSettingTemplet`, data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 基础档案->价格->价格配置->导入
 */
export async function ImportRangeSetting(data = {}, CSMID, IsComplete) {
	const res = await request.post(`/api/ba/CostSetting/ImportRangeSetting?CSMID=${CSMID}&IsComplete=${IsComplete}`,
		data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 日常工作->样品管理->申请样品->批量下载
 */
export async function GeneratePdfAPPSample(data = {}) {
	const res = await request.post(`/api/ba/APPSample/GeneratePdf`, data, {
		responseType: 'blob'
	});
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 基础档案->价格->价格配置->效期变更（经销商）
 */
export async function EditCustomerStartDate(data = {}) {
	const res = await request.post(`/api/ba/CostSetting/EditCustomerStartDate`, data);
	return res.data;
}
export async function EditCustomerEndDate(data = {}) {
	const res = await request.post(`/api/ba/CostSetting/EditCustomerEndDate`, data);
	return res.data;
}

/**
 * 
 * @param {*} data 
 * @returns 基础档案->价格->价格配置->效期变更（医院）
 */
export async function EditHospitalStartDate(data = {}) {
	const res = await request.post(`/api/ba/CostSetting/EditHospitalStartDate`, data);
	return res.data;
}
export async function EditHospitalEndDate(data = {}) {
	const res = await request.post(`/api/ba/CostSetting/EditHospitalEndDate`, data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 日常工作->样品管理->样品申请->负责销售
 */
export async function GetHelperAllSaler(data = {}) {
	const res = await request.post(`/api/helper/Helper/AllSaler`, data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 日常工作->样品管理->样品申请->分类
 */
export async function GetHelperSampleAdvType(data = {}) {
	const res = await request.get(`/api/helper/Helper/SampleAdvType`, data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 日常工作->样品管理->样品申请->最终确认
 */
export async function SetAPPSampleConfirm(data = {}) {
	const res = await request.post(`/api/ba/APPSample/Confirm`, data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 日常工作->样品管理->样品申请->回传单号
 */
export async function SetAPPSampleBackFill(data = {}) {
	const res = await request.post(`/api/ba/APPSample/BackFill`, data);
	return res.data;
}




/**
 *
 * @param {*} data
 * @returns 基础档案->业务->层级定义->列表
 */
export async function GetGradeStateList(data = {}) {
	const res = await request.post(`/api/ba/GradeState/List`, data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 基础档案->业务->层级定义->详情
 */
export async function GetGradeStateInfo(data = {}) {
	const res = await request.post(`/api/ba/GradeState/Info`, data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 基础档案->业务->层级定义->新增
 */
export async function AddGradeState(data = {}) {
	const res = await request.post(`/api/ba/GradeState/Add`, data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 基础档案->业务->层级定义->修改
 */
export async function EditGradeState(data = {}) {
	const res = await request.post(`/api/ba/GradeState/Edit`, data);
	return res.data;
}


/**
 *
 * @param {*} data
 * @returns 基础档案->业务->层级定义->删除
 */
export async function DeleteGradeState(data = {}) {
	const res = await request.post(`/api/ba/GradeState/Delete`, data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 获取一级组织
 */
export async function GetFirstOrganization(data = {}) {
	const res = await request.post(`/api/helper/Helper/FirstOrganization`, data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 基础档案->价格->价格配置->销售模式
 */
export async function GetSalesModelForCostSetting(data = {}) {
	const res = await request.post(`/api/helper/Helper/SalesModelForCostSetting`, data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 基础档案->价格->价格配置->计算
 */
export async function SetCostSettingByCSMID(data = {}) {
	const res = await request.post(`/api/ba/CostSetting/SetCostSettingByCSMID`, data);
	return res.data;
}


/**
 *
 * @param {*} data
 * @returns 工作日常->指标管理->经销商指标->根据季度计算每个月
 */
export async function ShareQuarterToMonth(data = {}) {
	const res = await request.post(`/api/ba/APPCustomer/ShareQuarterToMonth`, data);
	return res.data;
}



/**
 *
 * @param {*} data
 * @returns 报表->进销比->基础档案->列表
 */
export async function GetIMSNTSList(data = {}) {
	const res = await request.post(`/api/report/IMSNTS/List`, data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 报表->进销比->基础档案->类型下拉
 */
export async function GetHelperVBP(data = {}) {
	const res = await request.post(`/api/helper/Helper/VBP`, data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 报表->进销比->基础档案->省市
 */
export async function GetProvinceCityTree(data = {}) {
	const res = await request.post(`/api/helper/Region/ProvinceCityTree`, data);
	return res.data;
}


/**
 *
 * @param {*} data
 * @returns 报表->进销比->基础档案->产品名称
 */
export async function GetHelperInvName(data = {}) {
	const res = await request.post(`/api/helper/Helper/InvName`, data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 报表->进销比->基础档案->详情
 */
export async function InfoIMSNTSData(data = {}) {
	const res = await request.post(`/api/report/IMSNTS/Info`, data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 报表->进销比->基础档案->新增
 */
export async function AddIMSNTSData(data = {}) {
	const res = await request.post(`/api/report/IMSNTS/Add`, data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 报表->进销比->基础档案->编辑
 */
export async function EditIMSNTSData(data = {}) {
	const res = await request.post(`/api/report/IMSNTS/Edit`, data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 报表->进销比->基础档案->删除
 */
export async function DeleteIMSNTSData(data = {}) {
	const res = await request.post(`/api/report/IMSNTS/Delete`, data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 报表->进销比->基础档案->导入
 */
export async function ImportIMSNTSData(data = {}) {
	const res = await request.post(`/api/report/IMSNTS/Import`, data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 报表->进销比->基础档案->模板下载
 */
export async function DownloadIMSNTS(data = {}) {
	const res = await request.post(`/api/report/IMSNTS/DownloadTemplet`, data);
	return res.data;
}



/**********数据管理->基础档案管理->经销商->报量、订货经销商**********/

/**
 *
 * @param {*} data
 * @returns 基础档案管理->经销商->报量、订货经销商->列表
 */
export async function GetReportBuyerList(data = {}) {
	const res = await request.post(`/api/ba/ReportBuyer/List`, data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 基础档案管理->经销商->报量、订货经销商->详情
 */
export async function InfoReportBuyerData(data = {}) {
	const res = await request.post(`/api/ba/ReportBuyer/Info`, data);
	return res.data;
}


/**
 *
 * @param {*} data
 * @returns 基础档案管理->经销商->报量、订货经销商->新增
 */
export async function AddReportBuyerData(data = {}) {
	const res = await request.post(`/api/ba/ReportBuyer/Add`, data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 基础档案管理->经销商->报量、订货经销商->编辑
 */
export async function EditReportBuyerData(data = {}) {
	const res = await request.post(`/api/ba/ReportBuyer/Edit`, data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 基础档案管理->经销商->报量、订货经销商->删除
 */
export async function DeleteReportBuyerData(data = {}) {
	const res = await request.post(`/api/ba/ReportBuyer/Delete`, data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 基础档案管理->经销商->报量、订货经销商->导出
 */

export async function ExportReportBuyerData(data = {}) {
	const res = await request.post("/api/ba/ReportBuyer/Export", data, {
		responseType: "blob",
	});
	return res.data;
}


/**
 *
 * @param {*} data
 * @returns 基础档案管理->经销商->报量、订货经销商->导入模板下载
 */
export async function DownloadReportBuyer(data = {}) {
	const res = await request.post(`/api/ba/ReportBuyer/DownloadTemplet`, data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 基础档案管理->经销商->报量、订货经销商->导入
 */
export async function ImportReportBuyer(data = {}) {
	const res = await request.post(`/api/ba/ReportBuyer/Import`, data);
	return res.data;
}




/**********数据管理->基础档案管理->经销商->定义关联公司**********/


/**
 *
 * @param {*} data
 * @returns 基础档案管理->经销商->定义关联公司->推荐经销商
 */
export async function GetHelperBOSSCustomer(data = {}) {
	const res = await request.post(`/api/helper/Helper/BOSSCustomer`, data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 基础档案管理->经销商->定义关联公司->列表
 */
export async function GetBOSSCustomerList(data = {}) {
	const res = await request.post(`/api/ba/BOSSCustomer/List`, data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 基础档案管理->经销商->定义关联公司->详情
 */
export async function InfoBOSSCustomerData(data = {}) {
	const res = await request.post(`/api/ba/BOSSCustomer/Info`, data);
	return res.data;
}


/**
 *
 * @param {*} data
 * @returns 基础档案管理->经销商->定义关联公司->新增
 */
export async function AddBOSSCustomerData(data = {}) {
	const res = await request.post(`/api/ba/BOSSCustomer/Add`, data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 基础档案管理->经销商->定义关联公司->编辑
 */
export async function EditBOSSCustomerData(data = {}) {
	const res = await request.post(`/api/ba/BOSSCustomer/Edit`, data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 基础档案管理->经销商->定义关联公司->删除
 */
export async function DeleteBOSSCustomerData(data = {}) {
	const res = await request.post(`/api/ba/BOSSCustomer/Delete`, data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 基础档案管理->经销商->定义关联公司->导出
 */

export async function ExportBOSSCustomerData(data = {}) {
	const res = await request.post("/api/ba/BOSSCustomer/Export", data, {
		responseType: "blob",
	});
	return res.data;
}


/**
 *
 * @param {*} data
 * @returns 基础档案管理->经销商->定义关联公司->导入模板下载
 */
export async function DownloadBOSSCustomer(data = {}) {
	const res = await request.post(`/api/ba/BOSSCustomer/DownloadTemplet`, data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 基础档案管理->经销商->定义关联公司->导入
 */
export async function ImportBOSSCustomer(data = {}) {
	const res = await request.post(`/api/ba/BOSSCustomer/Import`, data);
	return res.data;
}


/**********数据管理->进销比->进销比报表->导出**********/

/**
 *
 * @param {*} data
 * @returns 数据管理->进销比->进销比报表->导出
 */

export async function ExportIMSNTSData(data = {}) {
	const res = await request.post("/api/report/IMSNTS/Report", data, {
		responseType: "blob",
	});
	return res.data;
}


/**********报表->报表类->新模式报表**********/




/**
 *
 * @param {*} data
 * @returns 报表->报表类->新模式报表->列表
 */
export async function GetOrgConsignmentList(data = {}) {
	const res = await request.post(`/api/report/SMSReport/OrgConsignment`, data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 报表->报表类->新模式报表->单据类型
 */
export async function OrgConsignmentVoucherType(data = {}) {
	const res = await request.post(`/api/helper/Helper/OrgConsignmentVoucherType`, data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 报表->报表类->新模式报表->状态
 */
export async function OrgConsignmentStatus(data = {}) {
	const res = await request.post(`/api/helper/Helper/OrgConsignmentStatus`, data);
	return res.data;
}


export async function ExportOrgConsignment(data = {}) {
	const res = await request.post("/api/report/SMSReport/OrgConsignmentExport", data, {
		responseType: "blob",
	});
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 产品追溯->导出
 */
export async function exportProductTraceability(data = {}) {
	const res = await request.post("/api/report/WMSReport/ProductTraceabilityExport", data, {
		responseType: "blob",
	});
	return res.data;
}


/**
 *
 * @param {*} data
 * @returns 报表->列表类->跟单打卡->列表
 */
export async function GetSfClockInList(data = {}) {
	const res = await request.post("/api/sf/ClockIn/List", data);
	return res.data;
}


/**
 *
 * @param {*} data
 * @returns 报表->列表类->跟单打卡->导出
 */
export async function ExportSfClockIn(data = {}) {
	const res = await request.post("/api/sf/ClockIn/Export", data, {
		responseType: "blob",
	});
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 报表->列表类->跟单打卡->图片打包下载
 */
export async function DownloadSfClockIn(data = {}) {
	const res = await request.post("/api/sf/ClockIn/GeneratePdf", data, {
		responseType: "blob",
	});
	return res.data;
}


/**
 *
 * @param {*} data
 * @returns 报表->列表类->跟单打卡->状态
 */
export async function GetHelperClockInStatus(data = {}) {
	const res = await request.post("/api/helper/Helper/ClockInStatus", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 报表->列表类->跟单打卡->明细
 */
export async function GetHelperClockInDetail(data = {}) {
	const res = await request.post("/api/sf/ClockIn/Detail", data);
	return res.data;
}


///////配送申请//////

/**
 *
 * @param {*} data
 * @returns 配送申请=>新增
 */
export async function APPHospitalDispatcherAdd(data = {}) {
	const res = await request.post("/api/ba/APPHospitalDispatcher/Add", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 配送申请=>列表 || 指标申请->新增
 */
export async function APPHospitalDispatcherList(data = {}) {
	const res = await request.post("/api/ba/APPHospitalDispatcher/List", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 配送申请=>查看
 */
export async function APPHospitalDispatcherInfo(data = {}) {
	const res = await request.post("/api/ba/APPHospitalDispatcher/Info", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 配送申请=>修改
 */
export async function APPHospitalDispatcherEdit(data = {}) {
	const res = await request.post("/api/ba/APPHospitalDispatcher/Edit", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 配送申请=>删除
 */
export async function APPHospitalDispatcherDelete(data = {}) {
	const res = await request.post("/api/ba/APPHospitalDispatcher/Delete", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 配送申请=>导出
 */

export async function APPHospitalDispatcherExport(data = {}) {
	const res = await request.post("/api/ba/APPHospitalDispatcher/Export", data, {
		responseType: "blob",
	});
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 配送申请=>提交
 */

export async function APPHospitalDispatcherSubmit(data = {}) {
	const res = await request.post("/api/ba/APPHospitalDispatcher/Submit", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 配送申请=>驳回
 */

export async function APPHospitalDispatcherReject(data = {}) {
	const res = await request.post("/api/ba/APPHospitalDispatcher/Reject", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 配送申请=>驳回配送
 */

export async function APPHospitalDispatcherRejectDispatch(data = {}) {
	const res = await request.post("/api/ba/APPHospitalDispatcher/RejectDispatch", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 配送申请=>撤回
 */

export async function APPHospitalDispatcherRevoke(data = {}) {
	const res = await request.post("/api/ba/APPHospitalDispatcher/Revoke", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 配送申请=>审批通过
 */

export async function APPHospitalDispatcherApprove(data = {}) {
	const res = await request.post("/api/ba/APPHospitalDispatcher/Approve", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 配送申请=>审批流程
 */

export async function APPHospitalDispatcherGetHostory(data = {}) {
	const res = await request.post(
		"/api/ba/APPHospitalDispatcher/GetHostory",
		data
	);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 配送申请=>状态
 */

export async function GetHelperLongApprovalFlowStatus(data = {}) {
	const res = await request.get(
		"/api/helper/Helper/LongApprovalFlowStatus",
		data
	);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 配送申请=>启用配送
 */

export async function APPHospitalDispatcherEnabled(data = {}) {
	const res = await request.post("/api/ba/APPHospitalDispatcher/Dispatch", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 配送申请=>导入
 */

export async function ImportAPPHospitalDispatcher(data = {}) {
	const res = await request.post("/api/ba/APPHospitalDispatcher/Import", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 配送申请=>导入模板下载
 */

export async function DownloadTempletDispatcher(data = {}) {
	const res = await request.post("/api/ba/APPHospitalDispatcher/DownloadTemplet", data);
	return res.data;
}
/**
 *
 * @param {*} data
 * @returns 配送申请=>渠道备注
 */

export async function APPHospitalDispatcherChannelRemark(data = {}) {
	const res = await request.post("/api/ba/APPHospitalDispatcher/ChannelRemark", data);
	return res.data;
}


/**
 *
 * @param {*} data
 * @returns 经销商库存对账=>调整数量==>查询名称
 */

export async function GetCheckVouchInvNamesList(data = {}) {
	const res = await request.post("/api/wms/CheckVouch/InvNamesList", data);
	return res.data;
}



/**
 *
 * @param {*} data
 * @returns 导出业务员档案
 */
export async function ExportSalerData(data = {}) {
	const res = await request.post("/api/helper/Helper/SalerExport", data, {
		responseType: "blob",
	});
	return res.data;
}


/**
 *
 * @param {*} data
 * @returns 导出医院档案
 */
export async function ExportHospitalData(data = {}) {
	const res = await request.post("/api/helper/Helper/HospitalExport", data, {
		responseType: "blob",
	});
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 下载LEVEL3列表
 */
export async function InvNameLEVEL3Export(data = {}) {
	const res = await request.post("/api/helper/Helper/InvNameLEVEL3Export", data, {
		responseType: "blob",
	});
	return res.data;
}


/**
 *
 * @param {*} data
 * @returns 报表=>业务透视==>IMS销售===>省份排名
 */

export async function GetProvinceIMSRanking(data = {}) {
	const res = await request.post("/api/report/SMSReport/ProvinceIMSRanking", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 日常工作=>工作报告==>龙虎榜===>新增
 */

export async function GetRankingList(data = {}) {
	const res = await request.post("/api/sf/RankingList/List", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 日常工作=>工作报告==>龙虎榜===>新增
 */

export async function AddRankingData(data = {}) {
	const res = await request.post("/api/sf/RankingList/Add", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 日常工作=>工作报告==>龙虎榜===>编辑
 */

export async function EditRankingData(data = {}) {
	const res = await request.post("/api/sf/RankingList/Edit", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 日常工作=>工作报告==>龙虎榜===>删除
 */

export async function DelRankingData(data = {}) {
	const res = await request.post("/api/sf/RankingList/Delete", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 日常工作=>工作报告==>龙虎榜===>导出
 */
export async function ExportRankingData(data = {}) {
	const res = await request.post("/api/sf/RankingList/Export", data, {
		responseType: "blob",
	});
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 猛犸龙虎榜===>列表
 */
export async function GetRankingMammothList(data = {}) {
	const res = await request.post("/api/sf/RankingMammoth/List", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 猛犸龙虎榜===>新增
 */
export async function AddRankingMammothData(data = {}) {
	const res = await request.post("/api/sf/RankingMammoth/Add", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 猛犸龙虎榜===>编辑
 */
export async function EditRankingMammothData(data = {}) {
	const res = await request.post("/api/sf/RankingMammoth/Edit", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 猛犸龙虎榜===>删除
 */
export async function DelRankingMammothData(data = {}) {
	const res = await request.post("/api/sf/RankingMammoth/Delete", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 猛犸龙虎榜===>导出
 */
export async function ExportRankingMammothData(data = {}) {
	const res = await request.post("/api/sf/RankingMammoth/Export", data, {
		responseType: "blob",
	});
	return res.data;
}

export async function GetHelperLevel3ForMammoth(data = {}) {
	const res = await request.post("/api/helper/Helper/LEVEL3ForMammoth", data);
	return res.data;
}


/**
 *
 * @param {*} data
 * @returns 日常工作=>配送申请==>新增/编辑===>上传图片
 */
/**
 * 刷新NTS产品线指标达成率
 * @param {*} data {Year, AccType, InvClass, ByQuarter}
 */
export async function RefreshNTSInvClassQuotachievingRate(data = {}) {
	const res = await request.post("/api/report/U8Report/RefreshNTSInvClassQuotachievingRate", data);
	return res.data;
}

/**
 * 获取NTS产品线指标达成率
 * @param {*} data {Year, AccType, InvClass, ByQuarter}
 */
export async function GetNTSInvClassQuotachievingRate(data = {}) {
	const res = await request.post("/api/report/U8Report/NTSInvClassQuotachievingRate", data);
	return res.data;
}

/**
 * 导出NTS产品线指标达成率
 * @param {*} data {Year, InvClass}
 */
export async function ExportNTSInvClassQuotachievingRate(data = {}) {
	const res = await request.post("/api/report/U8Report/NTSInvClassQuotachievingRateExport", data, {
		responseType: "blob",
	});
	return res.data;
}

/**
 * 产品线NTS配额接口
 */

// 列表
export async function GetInventoryClassNTSQuotaList(data = {}) {
	const res = await request.post("/api/ba/InventoryClassNTSQuota/List", data);
	return res.data;
}

// 详情
export async function GetInventoryClassNTSQuotaInfo(data = {}) {
	const res = await request.post("/api/ba/InventoryClassNTSQuota/Info", data);
	return res.data;
}

// 导出
export async function ExportInventoryClassNTSQuota(data = {}) {
	const res = await request.post("/api/ba/InventoryClassNTSQuota/Export", data, {
		responseType: "blob",
	});
	return res.data;
}

// 新增
export async function AddInventoryClassNTSQuota(data = {}) {
	const res = await request.post("/api/ba/InventoryClassNTSQuota/Add", data);
	return res.data;
}

// 修改
export async function EditInventoryClassNTSQuota(data = {}) {
	const res = await request.post("/api/ba/InventoryClassNTSQuota/Edit", data);
	return res.data;
}

// 删除
export async function DeleteInventoryClassNTSQuota(data = {}) {
	const res = await request.post("/api/ba/InventoryClassNTSQuota/Delete", data);
	return res.data;
}

// 导入模板下载
export async function DownloadInventoryClassNTSQuotaTemplet(data = {}) {
	const res = await request.post("/api/ba/InventoryClassNTSQuota/DownloadTemplet", data);
	return res.data;
}

// 导入
export async function ImportInventoryClassNTSQuota(data = {}) {
	const res = await request.post("/api/ba/InventoryClassNTSQuota/Import", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 日常工作=>配送申请==>新增/编辑===>上传图片
 */
export async function UploadAPPHospImage(data = {}) {
	const res = await request.post("/api/ba/APPHospitalDispatcher/UploadImage", data);
	return res.data;
}

/**
 * 医院科室档案
 */

// 列表
export async function GetTechnicalOfficesList(data = {}) {
	const res = await request.post("/api/ba/TechnicalOffices/List", data);
	return res.data;
}

// 详情
export async function GetTechnicalOfficesInfo(data = {}) {
	const res = await request.post("/api/ba/TechnicalOffices/Info", data);
	return res.data;
}

// 新增
export async function AddTechnicalOffices(data = {}) {
	const res = await request.post("/api/ba/TechnicalOffices/Add", data);
	return res.data;
}

// 修改
export async function EditTechnicalOffices(data = {}) {
	const res = await request.post("/api/ba/TechnicalOffices/Edit", data);
	return res.data;
}

// 删除
export async function DeleteTechnicalOffices(data = {}) {
	const res = await request.post("/api/ba/TechnicalOffices/Delete", data);
	return res.data;
}

// 导出
export async function ExportTechnicalOffices(data = {}) {
	const res = await request.post("/api/ba/TechnicalOffices/Export", data, {
		responseType: "blob",
	});
	return res.data;
}

// 导入模板下载
export async function DownloadTechnicalOfficesTemplet(data = {}) {
	const res = await request.post("/api/ba/TechnicalOffices/DownloadTemplet", data);
	return res.data;
}

// 导入
export async function ImportTechnicalOffices(data = {}) {
	const res = await request.post("/api/ba/TechnicalOffices/Import", data, {
		headers: {
			"Content-Type": "multipart/form-data;",
		},
	});
	return res.data;
}

// 类型下拉
export async function GetHelperTOType(data = {}) {
	const res = await request.get("/api/helper/Helper/TOType", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 平台业务分析报表
 */
export async function GetOrgStockMoneyChange(data = {}) {
	const res = await request.post("/api/report/SMSReport/OrgStockMoneyChange", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 平台业务分析报表导出
 */
export async function OrgStockMoneyChangeExport(data = {}) {
	const res = await request.post("/api/report/SMSReport/OrgStockMoneyChangeExport", data, {
		responseType: "blob",
	});
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 学术活动效果销量
 */
export async function GetActivityHospitalSalesByTendency(data = {}) {
	const res = await request.post("/api/report/SMSReport/ActivityHospitalSalesByTendency", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 获取LEVEL2列表
 */
export async function GetLevel2List(data = {}) {
	const res = await request.post("/api/helper/Helper/LEVEL2ForItem", data);
	return res.data;
}

/**
 *
 * @param {*} data
 * @returns 获取LEVEL3列表
 */
export async function GetLevel3List(data = {}) {
	const res = await request.post("/api/helper/Helper/LEVEL3ForItem", data);
	return res.data;
}

/**
 * 重点产品植入考核系数
 */
// 列表
export async function GetSalesTacticsList(data = {}) {
	const res = await request.post("/api/ba/SalesTactics/List", data);
	return res.data;
}

// 详情
export async function GetSalesTacticsInfo(data = {}) {
	const res = await request.post("/api/ba/SalesTactics/Info", data);
	return res.data;
}

// 新增
export async function AddSalesTactics(data = {}) {
	const res = await request.post("/api/ba/SalesTactics/Add", data);
	return res.data;
}

// 修改
export async function EditSalesTactics(data = {}) {
	const res = await request.post("/api/ba/SalesTactics/Edit", data);
	return res.data;
}

// 删除
export async function DeleteSalesTactics(data = {}) {
	const res = await request.post("/api/ba/SalesTactics/Delete", data);
	return res.data;
}

// 导入模板下载
export async function DownloadSalesTacticsTemplet(data = {}) {
	const res = await request.post("/api/ba/SalesTactics/DownloadTemplet", data);
	return res.data;
}

// 导入
export async function ImportSalesTactics(data = {}) {
	const res = await request.post("/api/ba/SalesTactics/Import", data, {
		headers: {
			"Content-Type": "multipart/form-data;",
		},
	});
	return res.data;
}

// 导出
export async function ExportSalesTactics(data = {}) {
	const res = await request.post("/api/ba/SalesTactics/Export", data, {
		responseType: "blob",
	});
	return res.data;
}

// 计算
export async function CompleteSalesTactics(data = {}) {
	const res = await request.get("/api/ba/SalesTactics/Complete", data, {
		timeout: 30 * 60 * 1000
	});
	return res.data;
}

/**
 * 获取产品促销分析图表数据
 */
export async function ProductSalesPromotionAnalyse(data = {}) {
	const res = await request.post("/api/report/U8Report/ProductSalesPromotionAnalyseDivisionInvClass", data);
	return res.data;
}

/**
 * 获取产品促销分析列表数据
 */
export async function ProductSalesPromotionAnalyseList(data = {}) {
	const res = await request.post("/api/report/U8Report/ProductSalesPromotionAnalyseList", data);
	return res.data;
}

/**
 * 导出产品促销分析列表数据
 */
export async function ProductSalesPromotionAnalyseExport(data = {}) {
	const res = await request.post("/api/report/U8Report/ProductSalesPromotionAnalyseExport", data, {
		responseType: "blob",
	});
	return res.data;
}
